import { ReduxState } from 'src/store/types';

export const dataSourceSelector =
  (dataSourceId: string | undefined) => (state: ReduxState) =>
    (dataSourceId && state.dataSources.dataSourcesById?.[dataSourceId]) || null;
